import React, { forwardRef, useImperativeHandle } from "react";

import { makeStyles, Paper, Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import CreativeDetails from "./CreativeDetails";

const useStyles = makeStyles((theme) => ({
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default forwardRef(
  (
    {
      isClickEnabled,
      isDragDisabled,
      isThumbnailEnabled,
      hasCampaignData = true,
      isDefault = false
    },
    ref
  ) => {
    const classes = useStyles();

    useImperativeHandle(ref, () => ({
      validate() {
        return {
          hasErrors: false,
          message: ""
        };
      }
    }));

    return (
      <React.Fragment>
        <Typography variant="h6" className={classes.h6}>
          Review and confirm selected placement(s) and creative(s)
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={hasCampaignData ? 7 : 12}>
            <HorizontalAssetList
              isClickEnabled={isClickEnabled}
              isDragDisabled={isDragDisabled}
              isThumbnailEnabled={isThumbnailEnabled}
              isWeightEnabled={true}
            />
          </Grid>
          {hasCampaignData ? (
            <Grid item xs={5}>
              <CreativeDetails
                hasCampaignData={hasCampaignData}
                isDefault={isDefault}
              />
            </Grid>
          ) : null}
        </Grid>
      </React.Fragment>
    );
  }
);
